
class YGProductGalleryMagnifier extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.gallery = this.closest("product-gallery");
    this.wrapper = this.closest(".product-gallery__media-list-wrapper");
    this.carousel = this.wrapper?.querySelector("media-carousel");
    this.mediaQuery = window.matchMedia("(min-width: 1000px) and (pointer: fine)");
    this.zoomLevel = Math.max(parseInt(this.gallery?.getAttribute("allow-zoom"), 10) || 2, 1);

    if (!this.gallery || !this.wrapper || !this.carousel) {
      return;
    }

    if (!this.closest(".shopify-section--main-product") || !this.gallery.classList.contains("product-gallery--desktop-carousel")) {
      return;
    }

    this.wrapper.addEventListener("pointermove", this.handlePointerMove.bind(this), {
      passive: true,
      signal: this.abortController.signal
    });
    this.wrapper.addEventListener("pointerleave", this.handlePointerLeave.bind(this), {
      signal: this.abortController.signal
    });
    this.carousel.addEventListener("click", this.handleCarouselClick.bind(this), {
      capture: true,
      signal: this.abortController.signal
    });
    this.gallery.addEventListener("carousel:change", this.handleSelectionChange.bind(this), {
      signal: this.abortController.signal
    });
    this.gallery.addEventListener("carousel:settle", this.handleSelectionChange.bind(this), {
      signal: this.abortController.signal
    });
    this.mediaQuery.addEventListener("change", this.handleViewportChange.bind(this), {
      signal: this.abortController.signal
    });
    window.addEventListener("resize", this.handleViewportChange.bind(this), {
      passive: true,
      signal: this.abortController.signal
    });
    window.addEventListener("scroll", this.handleViewportChange.bind(this), {
      passive: true,
      signal: this.abortController.signal
    });

    this.syncToSelectedMedia();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  handlePointerMove(event) {
    if (!this.isEnabled()) {
      this.deactivate();
      return;
    }

    if (event.target instanceof Element && event.target.closest("button, a[href]")) {
      this.deactivate();
      return;
    }

    const frame = this.getActiveFrame();

    if (!frame) {
      this.deactivate();
      return;
    }

    const pointerX = event.clientX - frame.mediaRect.left;
    const pointerY = event.clientY - frame.mediaRect.top;

    if (pointerX < 0 || pointerY < 0 || pointerX > frame.mediaRect.width || pointerY > frame.mediaRect.height) {
      this.deactivate();
      return;
    }

    this.syncToSelectedMedia(frame);
    this.style.backgroundPosition = `${(pointerX / frame.mediaRect.width) * 100}% ${(pointerY / frame.mediaRect.height) * 100}%`;
    this.classList.add("is-active");
  }

  handlePointerLeave() {
    this.deactivate();
  }

  handleCarouselClick(event) {
    if (!this.isEnabled()) {
      return;
    }

    if (event.target instanceof Element && event.target.closest("button, a[href]")) {
      return;
    }

    const frame = this.getActiveFrame();

    if (!frame) {
      return;
    }

    const pointerX = event.clientX - frame.mediaRect.left;
    const pointerY = event.clientY - frame.mediaRect.top;

    if (pointerX >= 0 && pointerY >= 0 && pointerX <= frame.mediaRect.width && pointerY <= frame.mediaRect.height) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  handleSelectionChange() {
    this.syncToSelectedMedia();
    this.deactivate();
  }

  handleViewportChange() {
    this.deactivate();
  }

  isEnabled() {
    return this.mediaQuery.matches && this.gallery?.hasAttribute("allow-zoom");
  }

  getSelectedMedia() {
    const media = this.carousel.selectedSlide || this.carousel.querySelector(".is-selected") || this.carousel.querySelector('.product-gallery__media[data-media-type="image"]:not([hidden])');

    if (!media || media.getAttribute("data-media-type") !== "image") {
      return null;
    }

    const image = media.querySelector("img");

    if (!image) {
      return null;
    }

    return { media, image };
  }

  getActiveFrame() {
    const selectedMedia = this.getSelectedMedia();

    if (!selectedMedia) {
      return null;
    }

    const mediaRect = selectedMedia.media.getBoundingClientRect();
    const wrapperRect = this.wrapper.getBoundingClientRect();

    if (mediaRect.width === 0 || mediaRect.height === 0) {
      return null;
    }

    return {
      ...selectedMedia,
      mediaRect,
      offsetLeft: mediaRect.left - wrapperRect.left,
      offsetTop: mediaRect.top - wrapperRect.top
    };
  }

  syncToSelectedMedia(frame = this.getActiveFrame()) {
    if (!frame || !this.isEnabled()) {
      this.deactivate();
      return;
    }

    const imageSource = frame.image.currentSrc || frame.image.src;

    if (!imageSource) {
      this.deactivate();
      return;
    }

    this.style.left = `${frame.offsetLeft}px`;
    this.style.top = `${frame.offsetTop}px`;
    this.style.width = `${frame.mediaRect.width}px`;
    this.style.height = `${frame.mediaRect.height}px`;
    this.style.borderRadius = getComputedStyle(frame.image).borderRadius;
    this.style.backgroundImage = `url("${imageSource}")`;
    this.style.backgroundSize = `${this.zoomLevel * 100}% ${this.zoomLevel * 100}%`;
  }

  deactivate() {
    this.classList.remove("is-active");
  }
}

if (!window.customElements.get("yg-product-gallery-magnifier")) {
  window.customElements.define("yg-product-gallery-magnifier", YGProductGalleryMagnifier);
}

  document.addEventListener('DOMContentLoaded', function () {
    class YGAnchorTab extends YGUtils {
      constructor() {
        super();
        this.observer = null;
        this.visibleAtc = new Set();
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          // 'atc-button': document.querySelector('.product-info [is="product-form"]') || document.querySelector('product-rerender [is="product-form"]'),
          'atc-button':
            document.querySelector('.product-info .product-info__buy-buttons') ||
            document.querySelector('product-rerender .product-info__buy-buttons') ||
            document.querySelector('.product-info [is="product-form"]') ||
            document.querySelector('product-rerender [is="product-form"]'),
          'parenEl': this.parentElement
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        this.isShow();
        
        // document.addEventListener('YGUpdate:scroll-tabs', this.updateEl.bind(this));
        document.addEventListener('variant:change', (e)=>{
          this.updateEl(e)
        });
        this.addEventListener('click', this.itemClick.bind(this));
      }

      itemClick(e) {
        let addToCart = e.target.closest('.yg-add-to-cart');
        let buyItNow = e.target.closest('.yg-buy-it-now');

        if (addToCart) {
          let addToCartBtn = document.querySelector('product-info product-form [type="submit"]') || 
                              document.querySelector('product-rerender product-form [type="submit"]') || 
                              document.querySelector('product-info [is="product-form"] [type="submit"]') || 
                              document.querySelector('product-rerender [is="product-form"] [type="submit"]');
          addToCartBtn.click();
        }
        if (buyItNow) {
          let buyItNowBtn =
            document.querySelector('product-info .shopify-payment-button .shopify-payment-button__more-options') ||
            document.querySelector('product-info shopify-buy-it-now-button .shopify-payment-button__button') || 
            document.querySelector('product-rerender .shopify-payment-button .shopify-payment-button__more-options') ||
            document.querySelector('product-rerender shopify-buy-it-now-button .shopify-payment-button__button') || 
            document.querySelector('product-rerender yg-buy-now-button button');
          buyItNowBtn.click();
        }
      }

      isShow() {
        if(this.dataset.template != 'product') {
          this.sectionsEl['parenEl'].classList.add('is-active')
          return
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.visibleAtc.add(entry.target);
              } else {
                this.visibleAtc.delete(entry.target);
              }
            });

            if (this.visibleAtc.size > 0) {
              this.sectionsEl['parenEl'].classList.remove('is-active'); // 有价格可见 → 隐藏自己
            } else {
              this.sectionsEl['parenEl'].classList.add('is-active'); // 全部不可见 → 显示自己
            }
          },
          {
            root: null,
            threshold: 0.1,
          }
        );

        this.observer.observe(this.sectionsEl['atc-button']);
      }

      updateEl(event) {
        const { scrollTabsEl } = event.detail;

        this.visibleAtc.clear();
        // this._sectionsEl['atc-button'] = document.querySelector('product-info [is="product-form"]') || document.querySelector('product-rerender [is="product-form"]');
        this._sectionsEl['atc-button'] = 
        document.querySelector('.product-info .product-info__buy-buttons') ||
        document.querySelector('product-rerender .product-info__buy-buttons') ||
        document.querySelector('.product-info [is="product-form"]') ||
        document.querySelector('product-rerender [is="product-form"]')
        this.isShow();

        scrollTabsEl && this.querySelector(`.yg-current-variant-container`)?.replaceWith(scrollTabsEl);
        if (!scrollTabsEl) {
          this.getLatestDom((html) => {
            const latestContainer = html.querySelector('.yg-current-variant-container');

            if (latestContainer) {
              const target = this.querySelector('.yg-current-variant-container');
              // 使用克隆节点以保留原始文档结构
              target?.replaceWith(latestContainer.cloneNode(true));
            }
          });
        }
      }
    }
    if (!window.customElements.get('yg-anchor-tab')) {
      window.customElements.define('yg-anchor-tab', YGAnchorTab);
    }
  });